import "./LabTestAndPanelsAddComponent.scss";
import FormTitleWithNavigationBack
    from "../../../../shared/components/form-title-with-navigation-back/FormTitleWithNavigationBack";
import React, {useCallback, useEffect} from "react";
import ButtonComponent from "../../../../shared/components/core/button/ButtonComponent";
import TabsWrapperComponent, {
    TabComponent,
    TabContentComponent,
    TabsComponent
} from "../../../../shared/components/tabs/tabsComponent";
import {useSelector} from "react-redux";
import StatusCardComponent from "../../../../shared/components/status-card/statusCardComponent";
import CheckBoxComponent from "../../../../shared/components/core/checkbox/CheckboxComponent";
import commonService from "../../../../shared/services/common.service";
import DrawerComponent from "../../../../shared/components/drawer/drawerComponent";
import {useSearchParams} from "react-router-dom";
import TestDetailsComponent from "../../../../shared/components/test-details/TestDetailsComponent";


interface LabTestAndPanelsAddComponentProps {
    labID: any;
    cancel: Function;
    next: Function;
    prev: Function;
    selectedTestsAndPanels: any;
}

const TESTS = 'tests';
const TEST_PANELS = 'test_panels';
const LabTestAndPanelsAddComponent = (props: LabTestAndPanelsAddComponentProps) => {
    const {labID, cancel, next, prev, selectedTestsAndPanels} = props;
    const [isEdited, setIsEdited] = React.useState(false);
    const [activeTab, setActiveTab] = React.useState<typeof TESTS|typeof TEST_PANELS>(TESTS);
    const {testListLite, testPanelList, biomarkerList} = useSelector((state: any) => state.staticData);
    const [viewDetailsDrawerOpen, setViewDetailsDrawerOpen] = React.useState(false);
    const [testOrPanelDetails, setTestOrPanelDetails] = React.useState<any>(undefined); // [testOrPanelDetails, setTestOrPanelDetails
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [selectedTestAndTestPanelIds, setSelectedTestAndTestPanelIds] = React.useState<any>({
        testIds: [],
        panelIds: []
    });
    const [searchParams] = useSearchParams();
    const lastCompletedStep = parseInt(searchParams.get("lastCompletedStep") || '0');


    useEffect(() => {
        if (selectedTestsAndPanels?.testIds?.length > 0 || selectedTestsAndPanels?.panelIds?.length > 0) {
            setIsEdited(true);
            setSelectedTestAndTestPanelIds(selectedTestsAndPanels);
        }
    }, [selectedTestsAndPanels]);

    const handleActiveTabChange = useCallback((tab: any) => {
        setActiveTab(tab);
    }, []);

    const handleViewDetailsDrawerOpen = useCallback((details: any) => {
        if (activeTab === TEST_PANELS) {
            const testNames = details?.testIds?.map((testId: any) => {
                const test = testListLite?.find((test: any) => test?.id === testId);
                return test.name;
            });
            const testObject = {...details, tests: testNames};
            setTestOrPanelDetails(testObject);
        } else {
            const biomarkerNames = details?.biomarkerIds?.map((biomarkerId: any) => {
                const biomarker = biomarkerList?.find((biomarker: any) => biomarker?.id === biomarkerId);
                return biomarker?.name;
            });
            setTestOrPanelDetails({...details, biomarkers: biomarkerNames});
        }
        setViewDetailsDrawerOpen(true);
    }, [testListLite, activeTab, biomarkerList]);

    const addLabTestAndPanels = useCallback(() => {
        setIsSubmitting(true);
        commonService._lab.addLabTestAndPanels(labID, {
            ...selectedTestAndTestPanelIds,
            lastCompletedStep: lastCompletedStep
        })
            .then((res: any) => {
                setIsSubmitting(false);
                next(selectedTestAndTestPanelIds);
            })
            .catch((err: any) => {
                setIsSubmitting(false);
            });
    }, [labID, selectedTestAndTestPanelIds, next, lastCompletedStep]);

    return (
        <div className={'lab-test-and-panels-add-component  screen t-form-screen'}>
            <FormTitleWithNavigationBack
                title={'Tests and Panels'}
                tooltipData={"Tests and Panels"}
                handleClick={prev}
            />
            <div className="t-form attachments-with-title-wrapper">
                <div className={'no-form'}>
                    <div className="t-form-controls-wrapper">
                        <div className={'lab-test-and-panel-tabs-wrapper'}>
                            <TabsWrapperComponent>
                                <TabsComponent
                                    value={activeTab}
                                    allowScrollButtonsMobile={false}
                                    variant={"fullWidth"}
                                    onUpdate={(e: any, v: any) => {
                                        handleActiveTabChange(v)
                                    }}
                                >
                                    <TabComponent label={"TESTS"} value={"tests"}/>
                                    <TabComponent label={"Test panels"} value={'test_panels'}/>
                                </TabsComponent>
                                <TabContentComponent selectedTab={activeTab} value={TESTS}>
                                    {
                                        testListLite && testListLite?.filter((test:any)=> test?.isActive)?.length > 0 ?
                                            testListLite?.filter((test:any)=> test?.isActive).map((test: any, index: any) => {
                                                    return (
                                                        <div key={index} className={'lab-list-item'}>
                                                            <div className={'lab-list-item-name-and-selection'}>
                                                                <CheckBoxComponent
                                                                    checked={selectedTestAndTestPanelIds?.testIds?.includes(test.id)}
                                                                    onUpdate={(isChecked: boolean) => {
                                                                        setIsEdited(true)
                                                                        if (isChecked) {
                                                                            setSelectedTestAndTestPanelIds((prevState: any) => {
                                                                                    return {
                                                                                        ...prevState,
                                                                                        testIds: [...prevState?.testIds, test.id]
                                                                                    }
                                                                                }
                                                                            )

                                                                        } else {
                                                                            // remove the test from the selected list
                                                                            setSelectedTestAndTestPanelIds((prevState: any) => {
                                                                                return {
                                                                                    ...prevState,
                                                                                    testIds: prevState?.testIds?.filter((id: any) => id !== test.id)
                                                                                }
                                                                            })
                                                                        }
                                                                    }}
                                                                    name={commonService.capitalizeFirstLetterOfEachWord(test.name)}
                                                                />
                                                                <div className={'lab-list-item-name'}>
                                                                    {commonService.capitalizeFirstLetterOfEachWord(test.name)}
                                                                </div>
                                                            </div>
                                                            <div className={'lab-list-item__action'}>
                                                                <div className={'underline-button'} onClick={() => {
                                                                    handleViewDetailsDrawerOpen(test);
                                                                }}>
                                                                    View Details
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            ) :
                                            <StatusCardComponent title={"No tests found"}/>
                                    }
                                </TabContentComponent>
                                <TabContentComponent selectedTab={activeTab} value={TEST_PANELS}>
                                    {
                                        testPanelList && testPanelList?.filter((panel:any)=> panel?.isActive)?.length > 0 ?
                                            testPanelList?.filter((panel:any)=> panel?.isActive)?.map((testPanel: any, index: number) => {
                                                    return (
                                                        <div key={index} className={'lab-list-item'}>
                                                            <div className={'lab-list-item-name-and-selection'}>
                                                                <CheckBoxComponent
                                                                    checked={selectedTestAndTestPanelIds?.panelIds?.includes(testPanel.id)}
                                                                    onUpdate={(isChecked: boolean) => {
                                                                        setIsEdited(true)
                                                                        if (isChecked) {
                                                                            setSelectedTestAndTestPanelIds((prevState: any) => {
                                                                                return {
                                                                                    ...prevState,
                                                                                    panelIds: [...prevState?.panelIds, testPanel.id]
                                                                                }
                                                                            });
                                                                        } else {
                                                                            setSelectedTestAndTestPanelIds((prevState: any) => {
                                                                                return {
                                                                                    ...prevState,
                                                                                    panelIds: prevState?.panelIds?.filter((id: any) => id !== testPanel?.id)
                                                                                }
                                                                            });
                                                                        }
                                                                    }}
                                                                    name={commonService.capitalizeFirstLetterOfEachWord(testPanel.name)}
                                                                />
                                                                <div className={'lab-list-item-name'}>
                                                                    {commonService.capitalizeFirstLetterOfEachWord(testPanel.name)}
                                                                </div>
                                                            </div>
                                                            <div className={'lab-list-item__action'}>
                                                                <div className={'underline-button'} onClick={() => {
                                                                    handleViewDetailsDrawerOpen(testPanel);
                                                                }}>
                                                                    View Details
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            ) :
                                            <StatusCardComponent title={"No test panels found"}/>
                                    }
                                </TabContentComponent>
                            </TabsWrapperComponent>
                        </div>
                    </div>
                    <div className='form-action-section'>
                        <ButtonComponent
                            type="button"
                            color={"primary"}
                            variant={"outlined"}
                            fullWidth={true}
                            handleClick={cancel}
                        >
                            Close
                        </ButtonComponent>
                        <ButtonComponent
                            type="button"
                            color={"primary"}
                            variant={"contained"}
                            fullWidth={true}
                            isLoading={isSubmitting}
                            handleClick={isEdited ? addLabTestAndPanels : next}
                        >
                            {isEdited ? "Next" : "Skip"}
                        </ButtonComponent>
                    </div>
                </div>
            </div>
            <DrawerComponent
                title={''}
                open={viewDetailsDrawerOpen}
                onClose={() => {
                    setViewDetailsDrawerOpen(false)
                }}
            >
                <TestDetailsComponent TESTS={TESTS} testOrPanelDetails={testOrPanelDetails} TEST_PANELS={TEST_PANELS}
                                      activeTab={activeTab}/>
            </DrawerComponent>
        </div>
    );

};

export default LabTestAndPanelsAddComponent;
